import { jsPDF } from "jspdf";
import JSZip from "jszip";
import { generate } from "../../api/label-creator";
import { Label } from "../../api/product-api";
import { generateExampleFieldsForLabel } from "../../utils";

const tapeTypeRegex = /\s*(.*?)\s*ink\s*on\s*(.*?)\s*tape.*?\s*([a-zA-Z0-9 ]+)/m;

export function generateLabelInfo(label: Label) {
    const metadata = label.metadata?.metadata;
    let output = "";

    if (!metadata) {
        return "Brak informacji";
    }

    if (metadata["tape-type"]) {
        output += "Drukarka: " + metadata["printer"] + "\n";
    }

    if (metadata["tape-type"]) {
        output += "Rodzaj taśmy: " + metadata["tape-type"] + "\n";
    }

    if (metadata["tape-width"]) {
        output += "Szerokość taśmy: " + metadata["tape-width"] + "\n";
    }

    return output.trim();
}

async function loadImage(url: string) {
    return new Promise<HTMLImageElement>((resolve, reject) => {
        const img = new Image();
        img.src = url;
        img.onload = () => {
            resolve(img);
        }
        img.onerror = (e) => {
            reject(e);
        }
    });
}

export async function generateDownloadZip(labels: readonly Label[], onProgress: (value: number | null) => void, type: "png" | "svg" | "pdf" | "pdf-separate") {
    if (type === "png" || type === "svg") {
        const zip = new JSZip();

        onProgress(0);

        for (let i = 0; i < labels.length; i++) {
            const label = labels[i];
            const metadata = { ...label.metadata?.metadata };

            const tapeType = label.metadata?.metadata["tape-type"].match(tapeTypeRegex);


            if (tapeType && tapeType[1] === "white") {
                metadata["invert"] = "true";
            }
            else if (metadata["invert"] === "true") {
                metadata["invert"] = "false";
            }

            const url = generate(
                label.path,
                generateExampleFieldsForLabel(metadata),
                metadata,
                true,
                type === "svg"
            );

            const response = await fetch(url)
            const data = await response.blob();

            const pathParts = label.path.split(".");
            pathParts.splice(pathParts.length - 1, 1);
            const path = pathParts.join(".") + "." + type;

            zip.file(path, data);

            onProgress(i / (labels.length - 1) * 0.9);
        }

        const content = await zip.generateAsync({ type: "blob" });
        const url = URL.createObjectURL(content);

        onProgress(null);

        const date = new Date();
        const a = document.createElement("a");
        a.style.display = "none";

        a.download = `labels_${type}_`
            + date.getFullYear()
            + (date.getMonth() + 1).toString().padStart(2, "0")
            + date.getDate().toString().padStart(2, "0")
            + "_"
            + date.getHours().toString().padStart(2, "0")
            + date.getMinutes().toString().padStart(2, "0")
            + date.getSeconds().toString().padStart(2, "0")
            + ".zip";

        a.href = url;
        a.click();
    }
    else if (type === "pdf") {
        const date = new Date();
        const fileName = `labels_${type}_`
            + date.getFullYear()
            + (date.getMonth() + 1).toString().padStart(2, "0")
            + date.getDate().toString().padStart(2, "0")
            + "_"
            + date.getHours().toString().padStart(2, "0")
            + date.getMinutes().toString().padStart(2, "0")
            + date.getSeconds().toString().padStart(2, "0")
            + ".pdf";

        const doc = new jsPDF({
            unit: "mm"
        });
        doc.deletePage(1);

        onProgress(0);

        for (let i = 0; i < labels.length; i++) {
            const label = labels[i];
            const metadata = { ...label.metadata?.metadata };

            const tapeType = label.metadata?.metadata["tape-type"].match(tapeTypeRegex);

            console.log(tapeType);

            if (tapeType && tapeType[1] === "white") {
                metadata["invert"] = "true";
            }
            else if (metadata["invert"] === "true") {
                metadata["invert"] = "false";
            }

            const url = generate(
                label.path,
                generateExampleFieldsForLabel(metadata),
                metadata,
                true,
                false
            );

            const img = await loadImage(url);
            const mmHeight = parseInt(metadata["tape-width"] ?? (img.height / 14).toString());
            const ratio = img.width / img.height;
            const mmWidth = mmHeight * ratio;
            const width = mmWidth;
            const height = mmHeight;

            doc.addPage([width, height], width > height ? "landscape" : "portrait")
                .addImage(img, "PNG", 0, 0, width, height);

            onProgress(i / (labels.length - 1));
        }

        onProgress(null);
        doc.save(fileName);
    }
    else if (type === "pdf-separate") {
        const zip = new JSZip();

        onProgress(0);

        for (let i = 0; i < labels.length; i++) {
            const doc = new jsPDF({
                unit: "mm"
            });
            doc.deletePage(1);

            const label = labels[i];
            const metadata = { ...label.metadata?.metadata };

            const tapeType = label.metadata?.metadata["tape-type"].match(tapeTypeRegex);

            console.log(tapeType);

            if (tapeType && tapeType[1] === "white") {
                metadata["invert"] = "true";
            }
            else if (metadata["invert"] === "true") {
                metadata["invert"] = "false";
            }

            const url = generate(
                label.path,
                generateExampleFieldsForLabel(metadata),
                metadata,
                true,
                false
            );

            const img = await loadImage(url);
            const mmHeight = parseInt(metadata["tape-width"] ?? (img.height / 14).toString());
            const ratio = img.width / img.height;
            const mmWidth = mmHeight * ratio;
            const width = mmWidth;
            const height = mmHeight;

            doc.addPage([width, height], width > height ? "landscape" : "portrait")
                .addImage(img, "PNG", 0, 0, width, height);

            const pathParts = label.path.split(".");
            pathParts.splice(pathParts.length - 1, 1);
            const path = pathParts.join(".") + ".pdf";

            zip.file(path, doc.output("blob"));

            onProgress(i / (labels.length - 1));
        }

        const content = await zip.generateAsync({ type: "blob" });
        const url = URL.createObjectURL(content);

        onProgress(null);

        const date = new Date();
        const a = document.createElement("a");
        a.style.display = "none";

        a.download = `labels_${type}_`
            + date.getFullYear()
            + (date.getMonth() + 1).toString().padStart(2, "0")
            + date.getDate().toString().padStart(2, "0")
            + "_"
            + date.getHours().toString().padStart(2, "0")
            + date.getMinutes().toString().padStart(2, "0")
            + date.getSeconds().toString().padStart(2, "0")
            + ".zip";

        a.href = url;
        a.click();
    }
}
